<div class="sidenav-container">
  <!-- Backdrop -->
  @if (isOpen()) {
  <!-- Backdrop click is acceptable UX - sidenav has keyboard-accessible menu items -->
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="backdrop" (click)="close()" data-testid="backdrop"></div>
  }

  <!-- Sidenav -->
  <nav class="sidenav" [class.open]="isOpen()">
    <ng-content select="[sidenav]"></ng-content>
  </nav>

  <!-- Content -->
  <div class="sidenav-content">
    <ng-content></ng-content>
  </div>
</div>